module.exports = __webpack_public_path__ + "media/images/icons/event_repeat-befd9ea3c1b65566ef8ed5e1538d0af1.svg";